import { graphql } from "@/graphql/generated/gql";

export const workspaceSettingsQueryDocument = graphql(/* GraphQL */ `
  query workspaceSettings($input: GetWorkspaceSettingsInput!) {
    workspaceSettings(getWorkspaceSettingsInput: $input) {
      ...WorkspaceSettingsFields
    }
  }
`);

export const updateWorkspaceSettingsMutationDocument = graphql(/* GraphQL */ `
  mutation updateWorkspaceSettings($input: UpdateWorkspaceSettingsInput!) {
    updateWorkspaceSettings(updateWorkspaceSettingsInput: $input) {
      ...WorkspaceSettingsFields
    }
  }
`);
